module.exports = __webpack_public_path__ + "img/sankaku_38_red.504e5435.png";